import React, {useState} from 'react'
import {AsideMenuItem} from '../AsideMenuItem'
import routerItems from '../../../../../app/routing/routerItems'
import {useIntl} from 'react-intl'
import i18nKeys from '../../../../i18n/i18nKeys'
import JobAiCreateModal from '../../../../../app/modules/super-admin-modules/jobs/components/JobAiCreateModal'
import useUser from '../../../../../app/hooks/useUser'
import UserRole from '../../../../../app/constants/userRoles'

export default function HrManagerAsideMenu() {
  const {formatMessage} = useIntl()
  const {isHiringManager} = useUser()
  const [showAddJobModal, setShowAddJobModal] = useState(false)
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-5 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {formatMessage({id: i18nKeys.HR_ADMIN_PAGES})}
          </span>
        </div>
      </div>

      {isHiringManager ? (
        <>
          <AsideMenuItem
            icon='/media/icons/duotune/general/gen016.svg'
            to={routerItems.HR_ADMIN_INVITE_APPLICANTS}
            title={'Invite Applicants / Search Jobs'}
          />
          <AsideMenuItem
            icon='/media/icons/duotune/graphs/gra010.svg'
            to={routerItems.HR_ADMIN_COMPARE_OVERALL_SCORE}
            title={'Compare Overall Score'}
          />
          <AsideMenuItem
            to={routerItems.MY_CLIENT_SITES_JOBS}
            title={formatMessage({id: i18nKeys.COMPANY_SITES_JOBS})}
            icon='/media/icons/duotune/general/gen018.svg'
          />
        </>
      ) : (
        <>
          <AsideMenuItem
            icon='/media/icons/duotune/communication/com005.svg'
            to={routerItems.HR_ADMIN_COMPANY_EMPLOYEES}
            title={formatMessage({id: i18nKeys.COMPANY_EMPLOYEES})}
          />
          <AsideMenuItem
            icon='/media/icons/duotune/general/gen016.svg'
            to={routerItems.HR_ADMIN_INVITE_APPLICANTS}
            title={'Invite Applicants / Search Jobs'}
          />
          <div className='menu-item'>
            <button
              type='button'
              className='menu-link without-sub border-0 bg-transparent w-100 text-start'
              onClick={() => setShowAddJobModal(true)}
            >
              <span className='menu-icon'>
                <i className='bi bi-plus-circle fs-3'></i>
              </span>
              <span className='menu-title'>Add a Job</span>
            </button>
          </div>
          <AsideMenuItem
            icon='/media/icons/duotune/graphs/gra001.svg'
            to={routerItems.HR_ADMIN_COMPARE_CANDIDATES}
            title={formatMessage({id: i18nKeys.COMPARE_CANDIDATES})}
          />
          <AsideMenuItem
            icon='/media/icons/duotune/graphs/gra002.svg'
            to={routerItems.HR_ADMIN_COMPARE_GROUP}
            title={formatMessage({id: i18nKeys.COMPARE_GROUP})}
          />
          <AsideMenuItem
            icon='/media/icons/duotune/graphs/gra010.svg'
            to={routerItems.HR_ADMIN_COMPARE_OVERALL_SCORE}
            title={'Compare Overall Score'}
          />
          <JobAiCreateModal show={showAddJobModal} onHide={() => setShowAddJobModal(false)} />
        </>
      )}
    </>
  )
}
